import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material';
import { CategoryService } from '../../../../_services/admin/category.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

  categoryList: any[] = [];
  tempCategoryList: any[] = [];

  constructor(private categoryService: CategoryService,
    private snackBar: MatSnackBar,
    private myTitle: Title,
    private router: Router) {
  }

  ngOnInit() {
    this.myTitle.setTitle('Product Categories | ' + environment.commonTitle);
    this.getAllCategory();
  }

  getAllCategory() {
    this.categoryService.getAllCategories().subscribe(result => {
      if (result.data) {
        this.categoryList = result.data;
        this.tempCategoryList = [...this.categoryList];
      }
    });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.tempCategoryList.filter(function (data) {
      return data.categoryName.toLowerCase().indexOf(val) !== -1 || !val;
    });
    this.categoryList = temp;
  }

  deleteCategory(id: number) {
    Swal({
      title: 'Are you sure you want to remove category?',
      text: '',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
      focusConfirm: false
    }).then((res) => {
      if (res.value) {
        this.categoryService.deleteCategory(id).subscribe(result => {
          if (result.data) {
            this.openSnackBar('Category deleted succcessfully.', 'Success');
            this.getAllCategory();
          }
        });
      } else if (res.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  addcategory() {
    this.router.navigate(['/secure/home/product/add-category']);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

  editCategory(id: any) {
    this.router.navigate(['/secure/home/product/edit-category/' + id]);
  }
}
